module.exports = __webpack_public_path__ + "static/media/pen_grey.a69ef288.svg";